export default "__VITE_ASSET__DKTtOH3S__"